import * as React from "react"

interface Props {
    color: string
}

export const PlaceholderWidget = ({ color }: Props): JSX.Element => {
    return (
        <div
            className={`theme-widget tw-mx-2 tw-mb-4 tw-self-start ${color}`}
        ></div>
    )
}

PlaceholderWidget.defaultProps = {
    color: "bg-cloud",
}

export default PlaceholderWidget
